import { Theme, makeStyles, createStyles } from '@material-ui/core';

type StylesProps = {
    paddingTop: number;
    isOpen: boolean;
    paddingLeftOnOpen: boolean;
};

const styles = (theme: Theme) =>
    createStyles({
        sidebar: {
            display: 'flex',
            height: '100%',
            [theme.breakpoints.down(1324)]: {
                'flex-direction': 'column',
            },
        },
        application: {
            position: 'relative',
            flexGrow: 1,
            paddingTop: ({ paddingTop }: StylesProps) => theme.spacing(paddingTop),
            [theme.breakpoints.up(1324)]: {
                paddingLeft: ({ paddingLeftOnOpen, isOpen }: StylesProps) => (paddingLeftOnOpen && isOpen ? 44 : 0),
            },
            [theme.breakpoints.down(1324)]: {
                marginTop: 44,
                paddingLeft: 0,
            },
            [theme.breakpoints.down('sm')]: {
                marginTop: 32,
                paddingLeft: 0,
            },
            [theme.breakpoints.down('xs')]: {
                marginTop: 26,
                paddingLeft: 0,
            },
            width: '100%',
            height: '100vh',
        },
    });

export default makeStyles(styles, { name: 'MuiShellSidebar' });
